import { useState, useEffect } from "react";
import { Link, Element, Events, scrollSpy, scroller } from "react-scroll";
import Footer2 from "./Footer2";
import Sponsorship from "./Sponsorship.js";
import Flowchart from "./Flowchart";
import "./Landing.css";
import "./SlideShow.css";
import TextType from "./TextType.js";
import domegallery3 from "./img/domegalery3.png";
import SC from "./SC";


function App() {
  return (
    <div className="app-container">
      <TextType
        text={["MAFFICK x TECHNOSEARCH"]}
        typingSpeed={75}
        pauseDuration={1500}
        showCursor={true}
        cursorCharacter="|"
        className="text"
      />
      <br /><br /><br />
      <img src={domegallery3} width="400px" height="400px" />
      <Flowchart />

      <SC />
      <br />
      <br />
      <p style={{ fontFamily: "Oswald", padding: "50px", fontSize: "25pt" }}>
        OUR SPONSORS
      </p>
      <Sponsorship />
      <Footer2 />
    </div>
  );
}

export default App;
